import { createListenerMiddleware, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'

import { RootState } from '@/store'
import { storeActions, ThunkExtra } from '@/store/actions'
import { getReportTemplates } from '@/store/report-templates/thunks'

const instance = createListenerMiddleware<
  RootState,
  ThunkDispatch<RootState, ThunkExtra, UnknownAction>
>()

instance.startListening({
  actionCreator: storeActions.initOrganization.fulfilled,
  effect: (
    {
      meta: {
        arg: { organizationId },
      },
    },
    listenerApi,
  ) => {
    listenerApi.cancelActiveListeners()
    listenerApi.dispatch(getReportTemplates({ organizationId }) as unknown as UnknownAction)
  },
})

export const reportTemplatesMiddleware = instance.middleware
